import { useEffect } from 'react';

import { useStable } from '~/src/common/hooks/useStable';

interface Props {
  onPressUp?: () => void;
  onPressDown?: () => void;
  onPressLeft?: () => void;
  onPressRight?: () => void;
}

export const useKeyboardArrowNavigation = (props: Props) => {
  // Stabilisation des références
  const onPressUp = useStable(() => props.onPressUp?.());
  const onPressDown = useStable(() => props.onPressDown?.());
  const onPressLeft = useStable(() => props.onPressLeft?.());
  const onPressRight = useStable(() => props.onPressRight?.());

  // Mise en place du handler pour les événements clavier
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'ArrowUp') onPressUp();
      else if (event.key === 'ArrowDown') onPressDown();
      else if (event.key === 'ArrowLeft') onPressLeft();
      else if (event.key === 'ArrowRight') onPressRight();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onPressUp, onPressDown, onPressLeft, onPressRight]);
};
